import { useSelector } from "react-redux"
import Select from "react-select"

export function SelectBox({ selectRef, ...props }) {
  const darkmode = useSelector((state) => state.Layout.darkmode)

  const customFilter = (option, searchText) => {
    return option?.data?.label?.toLowerCase().startsWith(searchText.toLowerCase()) ? true : false
  }

  const themechange = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "none"
    }
  })

  return (
    <>
      <Select
        className={props.onlyAssin ? "assign_field_box" : "select-box"}
        isClearable={false}
        {...props}
        theme={themechange}
        styles={{
          control: (base) => ({
            ...base,
            "&:hover": {
              borderColor: "none"
            },
            // height: "10px",
            backgroundColor: "none",
            border: "none"
          }),
          menuList: (base) => ({
            ...base,
            width: "auto",
            backgroundColor: `${darkmode ? "#3E3F3E" : "#FFFFFF"}`
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: `${darkmode ? "#3E3F3E" : "#FFFFFF"}`,
            zIndex: "9999"
          }),
          option: (styles, { isFocused }) => {
            return {
              ...styles,
              backgroundColor: isFocused ? "#4EB6EE" : null,
              color: `${darkmode ? "#FFFFFF" : "#3E3F3E"}`,
              height: "auto",
              width: "auto",
              paddingTop: "0px"
            }
          },
          singleValue: (styles) => ({
            ...styles,
            color: `${darkmode ? "#FFFFFF" : "#3E3F3E"}`
          })
        }}
        filterOption={customFilter}
      />
    </>
  )
}
